module.exports = __webpack_public_path__ + "assets/icons/ic_timer_24px.svg";